function closeToolTipWhenClickedOutside(): void {
  const buttons = document.querySelectorAll('.tooltip__trigger');

  document.addEventListener('click', function (e) {
    const target = e.target;
    if (!(target instanceof Element)) {
      return;
    }

    const isToolTipCloseButton = target.matches(
      '[data-tooltip-close], [data-tooltip-close] *'
    );

    if (target.matches('.tooltip__content a') && !isToolTipCloseButton) {
      return;
    }

    if (
      target.matches('.tooltip__content, .tooltip__content *') &&
      !isToolTipCloseButton
    ) {
      e.preventDefault();
      return;
    }

    if (target.matches('.tooltip *') && !isToolTipCloseButton) {
      return;
    }

    buttons.forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('tooltip-open');
    });
  });
}

export const tooltip = (selector: string): void => {
  const toolTipTriggers = document.querySelectorAll(
    `${selector} > button[type=button]`
  );

  closeToolTipWhenClickedOutside();
  // Toggle a class on body when tooltip toggles
  toolTipTriggers.forEach((trigger) => {
    trigger.addEventListener('click', function () {
      if (trigger.getAttribute('aria-expanded') === 'true') {
        trigger.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('tooltip-open');
      } else {
        document.body.classList.add('tooltip-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // Tooltip Close Button
  const closeButtons = document.querySelectorAll(
    `${selector} [data-tooltip-close]`
  );

  closeButtons.forEach((closeButton) => {
    closeButton.addEventListener('click', () => {
      const tooltipCheckbox = closeButton
        .closest('.tooltip__trigger')
        ?.querySelector('input[type=checkbox]');
      if (tooltipCheckbox instanceof HTMLInputElement) {
        tooltipCheckbox.checked = false;
      }
    });
  });
};
